import React, { useState, useEffect } from 'react';
import { Input } from 'formik-antd';
import { getIn, useFormikContext } from 'formik';
import { Container } from './styles';

export default function InputCurrency({ currency = true, prefix = 'R$', name = '', onChange = () => {}, ...props }) {
  const { values, setFieldValue } = useFormikContext();
  const formikValues = getIn(values, name);
  const [displayValue, setDisplayValue] = useState('0,00');

  useEffect(() => {
    if (formikValues !== undefined && formikValues !== null && formikValues !== '') {
      handleChange(formikValues);
    }
  }, [formikValues]);

  const formatValue = (inputValue) => {
    let safeValue = inputValue;

    if (typeof safeValue === 'number' && !isNaN(safeValue)) {
      safeValue = safeValue.toFixed(2);
    } else if (typeof safeValue === 'string' && safeValue.includes('.') && !safeValue.includes(',')) {
      safeValue = parseFloat(safeValue).toFixed(2);
    }

    const stringInput = String(safeValue);
    const minusCount = (stringInput.match(/-/g) || []).length;
    const isNegative = minusCount % 2 !== 0;
    const cleanedValue = stringInput.replace(/\D/g, '');
    const numericValue = parseFloat(cleanedValue) / 100 || 0;
    const finalValue = isNegative ? -numericValue : numericValue;

    return finalValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (e) => {
    const formattedValue = formatValue(e);

    setDisplayValue(formattedValue);
    setFieldValue(name, formattedValue);

    if (onChange) {
      onChange(formattedValue);
    }
  };

  const handleFocus = (e) => {
    const length = e.target.value.length;
    e.target.setSelectionRange(length, length);
  };

  const handleKeyUp = (e) => {
    const length = e.target.value.length;
    e.target.setSelectionRange(length, length);
  };

  return (
    <Container className="input-currency">
      {currency && <span className="currency">{prefix}</span>}
      <Input
        {...props}
        name={name}
        value={displayValue}
        onChange={(e) => handleChange(e.target.value)}
        onFocus={handleFocus}
        onKeyUp={handleKeyUp}
        className="input-antd"
      />
    </Container>
  );
}
